<template>
	<div id="videos-uploader-widget" :class="stream.type+'_uploadbox'">
		<Spinner v-if="loadingStatus" text="Retrieving data..." classes="text-dark-8 mt-5 w-full text-center" spinner-color="var(--c-dark-8)" spinner-size="15px" />
		<div class="w-full" v-else>
			<div v-if="widgetLoaded" class="uploader-body">
				<div v-if="!stream.liveParent && !advertisingMediaUpload" class="flex mb-4 flex-wrap items-start justify-start">
					<input :disabled="vodSubExpiredDays < 0" ref="uploadInputDrop" type="file" :multiple="allowMultipleUploads" style="display: none;" :accept="videoAccept" name="fields[assetsFieldHandle][]" id="assetsFieldHandleDrop" @change="onChange">
					<drop-down-menu
						v-if="uploadList.length > 0 || videoFiles.length > 0"
						:disabled="vodSubExpiredDays < 0"
						type="main"
						size="md"
						customClasses="flex items-center justify-between text-500 pl-2 mr-2"
						listClasses="dropdown-menu_md dropdown-menu_sm-100"
						class=""
					>
						<template #toggle-button>
							<div class="flex justify-between items-center w-full">
								<icon-base class="!mr-2 shrink-0" fill="none">
									<icon-plus />
								</icon-base>
								<span class="mr-auto">New Video</span>
								<icon-base class="!ml-2 shrink-0" fill="none">
									<icon-chevron-up-down />
								</icon-base>
							</div>	
						</template>

						<template #menu-items>
							<drop-down-menu-item v-if="!isDisabledControl && showUploadButton && (allowMultipleUploads || (videoFiles.length === 0 && uploadList.length === 0))" @click="openFileUpload()">From Your Computer</drop-down-menu-item>
							<drop-down-menu-item v-if="!isTrialSub" @click="openCloudImportModal('cloud-import-box-drop')">Cloud import <Badge type="main" class="badge_beta ml-2">beta</Badge></drop-down-menu-item>
						</template>
					</drop-down-menu>
					<div v-if="isDisabledControl" class="text-danger">Disable schedule to rearrange files</div>
					<!-- <input ref="uploadInputDrop" type="file" :multiple="allowMultipleUploads" style="display: none;" accept="video/mp4,video/x-m4v,video/*"> -->
					<FormButton v-if="uploadList.length && allowMultipleUploads" type="danger" size="md" class="ml-2 mt-4 lg:mt-0 z-fix" @click="clearUploadList">Remove All</FormButton>
					<div :class="{'drop-zone-hidden': ( videoFiles.length > 0 || uploadList.length > 0)}" class="w-full" @dragover="dragover" @dragleave="dragleave" @drop="drop">
						<input :disabled="vodSubExpiredDays < 0" ref="uploadInputDrop" type="file" :multiple="allowMultipleUploads" style="display: none;" :accept="videoAccept" name="fields[assetsFieldHandle][]" id="assetsFieldHandleDrop" @change="onChange">
						<label v-if="uploadList.length === 0 && videoFiles.length === 0" for="assetsFieldHandleDrop" :class="vodFiles.length > 0 ? 'drop-zone' : 'drop-zone-tall'" class="flex w-full">
							<div class="rounded-full drop-zone-circle drop-zone-circle_hovered flex flex-col items-center justify-center">
							<icon-base fill="none" width="48" height="48" width-view-box="48" height-view-box="48">
								<icon-playlist-empty-placeholder-image />
							</icon-base>
							<p class="text-s-m text-dark-9">Drag & drop or select a file</p>
							<p class="text-s-s text-dark-6 mb-2">Supported format: .mp4</p>
							<drop-down-menu :disabled="vodSubExpiredDays < 0" type="primary" size="md" listClasses="dropdown-menu_md dropdown-menu_sm-100" class="">
								<template #toggle-button>
									<div class="flex justify-between items-center w-full">
										<icon-base class="!mr-2 shrink-0" fill="none">
											<icon-plus />
										</icon-base>
										<span class="mr-auto">New Video</span>
										<icon-base class="!ml-2 shrink-0" fill="none">
											<icon-chevron-up-down />
										</icon-base>
									</div>	
								</template>

								<template #menu-items>
									<drop-down-menu-item v-if="!isDisabledControl && showUploadButton && (allowMultipleUploads || (videoFiles.length === 0 && uploadList.length === 0))" @click="openFileUpload()">From Your Computer</drop-down-menu-item>
									<Tooltip :active="cloudImportStorageTooltip" :content="cloudImportStorageTooltip">
										<drop-down-menu-item v-if="!isTrialSub" @click="openCloudImportModal('cloud-import-box-drop')">
											Cloud import
										</drop-down-menu-item>
									</Tooltip>
								</template>
							</drop-down-menu>
							</div>
						</label>
						<label v-else for="assetsFieldHandle" class="flex" :class="vodFIles.length > 0 ? 'drop-zone' : 'drop-zone-tall'">
							<div class="rounded-full drop-zone-circle flex flex-col items-center justify-center">
								<icon-base class="mb-4" fill="none" width="48" height="48" width-view-box="48" height-view-box="48">
									<icon-playlist-empty-placeholder-image />
								</icon-base>
								<p class="text-s-m text-dark-9">Release files to upload</p>
							</div>
						</label>
					</div>
					<ModalBox v-model="legacyModalVisible" size="md" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none">

						<UppyUploader v-if="storageRestricitonsLoaded"
							:stream="stream" 
							:max-files="5" 
							:max-total-file-size="aioStorageLimit && typeof aioStorageLimit.unitsLeft === 'number' ? Math.min(maxTotalFileSize || Infinity, Math.max(0, aioStorageLimit.unitsLeft)) : maxTotalFileSize"
							:maxFileSize="maxVideoFileSize * (1000 **3)"
							:storageLimit="aioStorageLimit"
							@upload-success="onVideoAdded"
							:encodingPresets="canEncodeVideos ? availableEncodingPresets : []"
						/>
					
</ModalBox>
				</div>
				<div @dragover="dragover" @dragleave="dragleave" @drop="drop" class="video-list">
					<Alert v-if="hasIncompatibleMediaFiles" type="normal" class="text-dark-7 text-s-s flex p-2">
						<div>
							<p class="m-0 text-dark-9 text-s-m font-medium">This file doesn't match our recommended settings</p>
							<p class="text-s-s m-0">Playback may be unstable. For best results, re-encode it using our <a href="https://docs.castr.io/en/articles/5161326-recommended-settings-for-recorded-videos" target="_blank" class="text-underline text-dark-8">recommended settings</a>. If you'd rather use it as-is, run a quick test stream first.</p>
						</div>
					</Alert>
				</div>
			</div>
		</div>
		
		<alert-modal
			:message="uploadErrorMessage || 'You are exceeding your storage limit. Please upgrade to continue'"
			modal-id="alert-storage-exceeding"
			ok-text="Got it, thanks"
			button-alignment="text-right"
		/>
		<upload-alert-modal
			modal-id="alert-video-max-size1"
			:message="maxFileSizeErrorTitle"
			:body="maxFileSizeErrorMessage|| 'This file is too large. Upload a smaller file or upgrade your plan to continue.'"
			ok-text="Cancel"
			button-alignment="text-right"
		/>
		<alert-modal
			:message="maxFileNumberErrorMessage || 'You have reached your file limit. Upgrade your plan to upload more.'"
			modal-id="alert-video-max-file"
			ok-text="Got it, thanks"
			button-alignment="text-right"
		/>
		<alert-modal
			message="Please upload MP4 files only."
			modal-id="forbidden-file-format-modal-drop"
			ok-text="Ok"
			button-alignment="text-right"
		/>
	</div>
</template>
<script>
import { showModal, hideModal } from '@/Utils/modalBus'
import { APP_EVENTS, emitAppEvent } from '@/Utils/appEventBus'
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import Tooltip from '@/components/Atoms/Tooltip.vue'
import Spinner from "@/components/ui/Spinner.vue"
import StreamService from '@/services/StreamService';
import UserService from "@/services/UserService";
import utils from '@/utils';
import Dropzone from '@/components/Dropzone.vue';
import AlertModal from '@/components/modals/AlertModal.vue';
import UploadAlertModal from '@/components/modals/UploadAlertModal.vue';
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import DropDownMenuItem from '@/components/Atoms/DropDownMenuItem.vue'
import _ from 'lodash';
import { VIDEO_UPLOAD_ACCEPT, MP4_ONLY_ERROR_MESSAGE, hasDisallowedVideoFile } from '@/Utils/videoUploadFormats';
import { loadMediaInfoLib } from '@/Utils/mediaInfoLoader';
import UppyUploader from '@/components/UppyUploader.vue';
import MetricsService from '@/services/MetricsService';
import { mapGetters } from 'vuex'
import FormButton from '@/components/Atoms/FormButton.vue';
import Alert from '@/components/Atoms/Alert.vue';
import Badge from '@/components/Badge.vue';
import IconBase from '../icon/IconBase.vue';
import IconPlus from '../icon/IconPlus.vue';
import IconChevronUpDown from '../icon/IconChevronUpDown.vue';
import IconPlaylistEmptyPlaceholderImage from '../icon/IconPlaylistEmptyPlaceholderImage.vue';

export default {
	name: 'VODUploadWidgetDrop',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'cloud-import-box-drop',
	components: {
		ModalBox,
		Tooltip,
    DropDownMenu,
    DropDownMenuItem,
		Alert,
		FormButton,
		Dropzone,
		Spinner,
		AlertModal,
		UploadAlertModal,
		UppyUploader,
		Badge,
		IconBase,
		IconPlus,
		IconChevronUpDown,
		IconPlaylistEmptyPlaceholderImage,
	},
	props: {
		stream: {
			type: Object,
			required: true,
			validator(v) {
				return Object.prototype.hasOwnProperty.call(v, '_id');
			}
		},
		mediaOnline: {
			type: Boolean,
		},
		schedulerSettings: {
			type: Object,
			default() { return {}; }
		},
		isOneMinuteBefore: {
			type: Boolean
		},
		streamAlive: {
			type: Boolean
		},
		canEncodeVideos: {
			type: Boolean,
			default: false
		},
		multipleUploads: {
			type: Boolean,
			default: true
		},
		maxFiles: {
			type: Number,
			default: 1
		},
		totalFilesPerStream: {
			type: Number,
			default: 1000000
		},
		videoFiles: {
			type: Array,
			default: () => []
		},
		mp4Only: {
			type: Boolean,
			default: true
		},
		isDisabledControl: {
			type: Boolean,
			default: false
		},
		isVodTrial: {
         type: Boolean,
         default() { return false }
		},
		vodSubExpiredDays: {
				type: Number,
				default() { return 1 }
		},
		advertisingMediaUpload: {
			type: Boolean,
			default: false
		},
		aioStorageLimit: {
			type: Object,
			default() { return {}; }
		},
	},
	data() {
		return {
			videoAccept: VIDEO_UPLOAD_ACCEPT,
			appUpdate: false,
			mediaInfoLib: null,
			widgetLoaded: false,
			processing: true,
			uploadErrorMessage: null,
			maxFileSizeErrorTitle: null,
			maxFileSizeErrorMessage: null,
			maxTotalFileSize: null,
			storageRestricitonsLoaded: false,
			scheduledSub: null,
			maxFileNumberErrorMessage: null,
			uploadWidgetMaximized: false,
			uploadWidgetCollapse: true,
			uploadList: [],
			availableEncodingPresets: [
				{ id: '360p', text: '360p', minHeight: 300 },
				{ id: '480p', text: '480p', minHeight: 440 },
				{ id: '720p', text: '720p', minHeight: 700 },
				{ id: '1080p', text: '1080p', minHeight: 1020 }
			],
			filesDragging: false,
			allowMultipleUploads: this.multipleUploads,
			showUploadButton: true,
			cloudImp:false,
			showOptions:false,
		};
	},
	computed: {
		...mapGetters({
			loadingStatus: "Ui/loadingStatus",
			uploadFiles: "Ui/uploadFiles",
			vodFiles: "Streams/vodFiles",
			vodStreams: "Streams/vodStreams"
		}),
		streamKey() {
			// in live-to-vod, all the keys should be equal
			const v = this.videoFiles.find(x => x.archive?.key);
			return v?.archive?.key;
		},
		activeTeam(){
			return this.$store.state.User.activatedTeam;
		},
		shouldCheckMediaQuality() {
			return this.$route.name === 'ScheduledStreamManageDashboard'
		},
		hasIncompatibleMediaFiles(){
			return this.uploadFiles.some(media => media?.mediaInfo && !this.isMediaCompatible(media.mediaInfo))
		},
		maxVideoFileSize() {
			let maxSize = null;
			const subscriptions =  _.cloneDeep(this.$store.state.User.subscriptions);

			if (this.stream.type === 'vod' && this.aioStorageLimit) {
				maxSize = 1000
				return maxSize
			}

			const activeScheduledSubs = _.filter(subscriptions, (sub) => sub.category === 'scheduled' && sub.enabled === true)
			
			activeScheduledSubs.forEach(sub => {
				try {
					if (sub.definitionOverride && sub.definitionOverride.schedulerMaxVideoSize) {
						sub.package.definition.schedulerMaxVideoSize = parseFloat(sub.definitionOverride.schedulerMaxVideoSize)
					}
					if (maxSize) {
						const tmpMaxSize = parseFloat(sub.package.definition.schedulerMaxVideoSize);
						if (tmpMaxSize > maxSize) {
							maxSize	= tmpMaxSize;
						}
					} else {
						maxSize	= parseFloat(sub.package.definition.schedulerMaxVideoSize);
					}
				} catch (error) {
					console.error(error);
				}
			})

			return maxSize
		},
		scheduledStorage() {
			let scheduledStorage = null;
			const subscriptions = this.$store.state.User.subscriptions;

			const activeScheduledSubs = _.filter(subscriptions, (sub) => sub.category === 'scheduled' && sub.enabled === true)
			
			activeScheduledSubs.forEach(sub => {
				try {
					let overrideStorage = parseFloat(sub.package.definition.storage);
					if (sub.definitionOverride && sub.definitionOverride.storage) {
						overrideStorage = parseFloat(sub.definitionOverride.storage)
					}
					if (scheduledStorage) {
						const tmpMaxSize = overrideStorage;
						if (tmpMaxSize > scheduledStorage) {
							scheduledStorage	= tmpMaxSize;
							this.scheduledSub = sub
						}
					} else {
						scheduledStorage = overrideStorage
						this.scheduledSub = sub
					}
				} catch (error) {
					console.error(error);
				}
			})

			return scheduledStorage
		},
		maxNumberOfVideoFiles() {
			return this.maxFiles;
		},
		vodStorageLimit() {
			return parseFloat(this.$store.state.User.maxVodStorage);
		},
		isTrialSub() {
			let isTrialSub = false;
			let isPaidSub = false;
			const subscriptions = this.$store.state.User.subscriptions;
			subscriptions.forEach(sub => {
				try {
					if (['5cd5485126fd039846a3255f', '5ccd92f8152b7f25111c39cf', '5e8db3dcc3db0533322db725',
								'6362114709950a6a642540c4', '6362114709950a6a642540c2', '6362114709950a6a642540c3'].indexOf(sub.package._id) !== -1 && sub.enabled === true) {
						isTrialSub = true;
					} else if (sub.enabled === true) {
						isPaidSub = true;
					}
				} catch (error) {
					console.error(error);
				}
			})
			return isPaidSub ? false : isTrialSub;
		},
		scheduleSubscriptionsStatus() {
			const subscriptions = this.$store.state.User.subscriptions;
			const scheduledSubscriptions = _.filter(subscriptions, (sub) => sub.category === 'scheduled');
			const result = scheduledSubscriptions.find(element => element.enabled === true);
			if (result) {
				return true
			} else return false;
		},
		cloudImportStorageTooltip() {
			if (this.aioStorageLimit && typeof this.aioStorageLimit.unitsLeft === 'number' && this.aioStorageLimit.unitsLeft <= 0) {
				return 'Uploads are disabled because your storage limit is exceeded. Upgrade your plan for more storage.';
			}
			return null;
		},
	},
	
	async mounted() {
		this.setupMediaLibs();
		this.setupAWSLibs();
		await this.initVideoUpload()
		this.maxFileSizeIntervalCtrl = setInterval(() => {
			this.initMaxFileSizeData();
		}, 3000);
	},
	unmounted() {
		clearInterval(this.maxFileSizeIntervalCtrl);
		// this.uploadList.forEach(this.cancelVideoUpload.bind(this));
	},
	directives: {
		'click-outside': {
			mounted: function (el, binding, vnode) {
				el.clickOutsideEvent = function (event) {
					// console.log(event.target.classList[0].includes("uppy") );
				// here I check that click was outside the el and his children
				if (!(el == event.target || el.contains(event.target))) {
					// and if it did, call method provided in attribute value
					let uppywrapper = false;
					if(event.target.classList[0]){
						uppywrapper = event.target.classList[0].includes("uppy");
					}
					if((event.target.tagName == 'BUTTON' || event.target.tagName == 'SPAN')){
						var closest = event.target.tagName;
					}else{
						var closest = event.target.closest('.cloud-import-box-drop')
					}
					if(closest != null){
						uppywrapper = true;
					}
					if(!uppywrapper && typeof binding.value === 'function'){binding.value(event);}
					
				}
				};
				document.body.addEventListener('click', el.clickOutsideEvent)
			},
			unmounted: function (el) {
				document.body.removeEventListener('click', el.clickOutsideEvent)
			},
		}
	},
	methods: {
		openFileUpload() {
			// Computer uploads go through the shared Uppy dashboard.
			emitAppEvent(APP_EVENTS.OPEN_VOD_UPLOADER, { stream: this.stream });
		},
		openCloudImportModal(modalId) {
			if (this.aioStorageLimit && typeof this.aioStorageLimit.unitsLeft === 'number' && this.aioStorageLimit.unitsLeft <= 0) {
				return;
			}
			showModal(modalId);
		},
		onClickShare() {
		},
		isMediaCompatible(mediaInfo) {
			if(!this.shouldCheckMediaQuality) return true

			if(mediaInfo.hasAudioTrack && !mediaInfo.isVbr) return true
			return false
		},
		getErrorMessage(mediaInfo){
			let message = ''
			
			if(mediaInfo.isVbr) {
				message = 'File should be CBR-encoded'
			}

			if(!mediaInfo.hasAudioTrack) {
				if(mediaInfo.isVbr) message += ' and have sound'
				else message = 'File should have sound'
			}

			message += '.'

			return message
		},
		toggleCI: function() {
			if(this.cloudImp == true){
    		this.cloudImp = false;
			}
			
    	},
		onVideoAdded(videoItem) {
			this.$emit('video-added', videoItem);
			this.cloudImp = false;
			this.showOptions = false;
		},
		setupAWSLibs() {
			const vm = this
			let scriptId = 'aws-js'
			if (!document.getElementById(scriptId)) {
				// async load mediainfo js
				let scriptEl = document.createElement('script')
				scriptEl.src = 'https://sdk.amazonaws.com/js/aws-sdk-2.663.0.min.js'
				scriptEl.setAttribute('id', scriptId)
				scriptEl.onload = function() { initClass() }
				document.head.appendChild(scriptEl)
			} else {
				initClass()
			}

			function initClass() { vm.awsLoaded = true }
		},
		onFilesDrop(e) {
			e.preventDefault();
			e.stopPropagation();
			this.showOptions = false;
			if (e.dataTransfer.items) {
				for (const file of e.dataTransfer.items) {
					if (file.kind === 'file' && file.type.startsWith('video')) this.onMediaAdd(file.getAsFile());
				}
			} else {
				for (const file of e.dataTransfer.files) {
					if (file.type.startsWith('video')) this.onMediaAdd(file);
				}
			}
		},
		onMediaPresetSelect(media) {
			setTimeout(() => media.encodingUnitsRequired = computeEncodingUnits(media), 0);
		},
		isPresetSupported(media, preset) {
			return !media.mediaInfo ? false : media.mediaInfo.height >= preset.minHeight;
		},
		togglePresetList(media) {
			media.presetListCollapse = !media.presetListCollapse;
		},
		setupMediaLibs() {
			return loadMediaInfoLib()
				.then((lib) => {
					this.mediaInfoLib = lib;
					this.widgetLoaded = true;
				})
				.catch((error) => {
					console.error('Failed to load MediaInfo library', error);
				});
		},
		async initMaxFileSizeData() {
			// Check max video file size (GB)
			let totalVodBytes = 0;
			const vodStorageTherehold = this.vodStorageLimit
			if (this.stream.type === 'vod' && vodStorageTherehold) {
				const streams = this.vodStreams;
				
				streams.forEach((item) => {
					if (item.type === 'vod' && !item.liveParent) {
						totalVodBytes += item.totalBytes
					}
				})

				if (totalVodBytes > 0) {
					totalVodBytes = totalVodBytes / (1000 ** 3)
				}

				this.maxTotalFileSize = (vodStorageTherehold - totalVodBytes) * (1000 ** 3);
			}

			this.storageRestricitonsLoaded = true;
		},
		async initVideoUpload() {
			const el = this.$refs.uploadInputDrop;
			if (!el) {
				setTimeout(() => this.initVideoUpload(), 5000);
				return;
			}

			const vm = this;

			// Prevent uploads when subscription storage has no units left
			if (el.files.length && this.aioStorageLimit && typeof this.aioStorageLimit.unitsLeft === 'number' && this.aioStorageLimit.unitsLeft <= 0) {
				const assignedGB = this.aioStorageLimit.assigned
					? (this.aioStorageLimit.assigned / (1000 ** 3)).toFixed(1)
					: this.vodStorageLimit;
				vm.maxFileSizeErrorTitle = `Your storage limit has been exceeded`
				vm.maxFileSizeErrorMessage = `Your VOD storage limit (${assignedGB}GB) has been exceeded. Upgrade now to increase your video upload capacity.`
				vm.$showModal('alert-video-max-size1');
				el.value = null;
				return;
			}

				if (!el.files.length) return;
				// Calculate max video files of the scheduled stream
				let maxFiles =  vm.maxNumberOfVideoFiles;
				maxFiles = vm.totalFilesPerStream - vm.videoFiles.length - vm.uploadList.length;
				if (el.files.length > maxFiles) {
					vm.maxFileNumberErrorMessage = `You can only upload a maximum of ${vm.totalFilesPerStream} files. Upgrade your plan if you need more files.`
					vm.$showModal('alert-video-max-file');
					el.value = null;
					return;
				};

				// Check max video file size (GB)
				let totalVodBytes = 0;								// total usage of all active(without deleted/archived) VOD + pseudoVOD(live to vod) 
				let totalRealVodBytes = 0							// total usage of all active(without deleted/archived) VOD

				const vodStorageTherehold = vm.vodStorageLimit
				if (vm.stream.type === 'vod' && vodStorageTherehold) {
					const streams = this.vodStreams;
					
					streams.forEach((item) => {
						if (item.type === 'vod') {
							totalVodBytes += item.totalBytes
						}

						if (item.type === 'vod' && !item.liveParent) {
							totalRealVodBytes += item.totalBytes
						}
					})

					if (totalVodBytes > 0) {
						totalVodBytes = totalVodBytes / (1000 ** 3)
					}

					if (totalRealVodBytes > 0) {
						totalRealVodBytes = totalRealVodBytes / (1000 ** 3)
					}

					let uploadQueueBytes = 0
					// console.log(el.files);
					// console.log(el.files[0]);
					if(Array.isArray(el.files)) {
						el.files.forEach((item) => {
							uploadQueueBytes = uploadQueueBytes + (item.size / (1000 ** 3))
						})
					} else {
						
						Object.entries(el.files).forEach(
							([key, value]) => {
								// console.log(value.size),
								uploadQueueBytes = uploadQueueBytes + (value.size / (1000 ** 3))
							}
						);

						// el.files.forEach((item) => {
						// 	uploadQueueBytes = uploadQueueBytes + (item.size / (1000 ** 3))
						// })
					}
					

					const uploadQueue = vm.uploadList || []
					uploadQueue.forEach((item) => {
						uploadQueueBytes = uploadQueueBytes + (item.file.size / (1000 ** 3))
					})

					if((totalRealVodBytes + uploadQueueBytes) > vodStorageTherehold) {
						// console.log(`Storage capacity cannot exceed ${vodStorageTherehold}GB. Upgrade your plan to continue.`);
						vm.maxFileSizeErrorTitle = `Your storage limit has been exceeded`
						vm.maxFileSizeErrorMessage = `Your VOD storage limit (${vodStorageTherehold}GB) has been exceeded. Upgrade now to increase your video upload capacity.`
						
						vm.$showModal('alert-video-max-size1');
						el.value = null;
						return;
					}
				}

				if (vm.stream.type === 'scheduled') {
					if (_.isNumber(vm.scheduledStorage)) {
						let fileSize = 0
						_.forEach(el.files, (file) => fileSize += (file.size / (1000 ** 3)));

						// Get storage usage
						const userId = vm.$store.state.User._id;
						const packageId = vm.scheduledSub.package._id
						const storageUsage = await MetricsService.getSubscriptionStorage(userId, packageId)
						const overStorage = (vm.scheduledStorage - (storageUsage?.bytes / (1000 ** 3)) - fileSize) < 0
						if (overStorage) {
							vm.maxFileSizeErrorMessage = `Storage capacity cannot exceed ${vm.scheduledStorage}GB. Upgrade your plan to continue.`
							
							vm.$showModal('alert-video-max-size');
							el.value = null;
							return;
						}
					}
					if (_.isNumber(vm.maxVideoFileSize)) {
						const overMaxSize = _.find(el.files,(file) => (file.size / (1000 ** 3)) > (vm.maxVideoFileSize - totalVodBytes));
						if (overMaxSize) {
							vm.maxFileSizeErrorMessage = `Your file size cannot exceed ${vm.maxVideoFileSize}GB. Upload smaller file or upgrade your plan to continue.`
							
							vm.$showModal('alert-video-max-size');
							el.value = null;
							return;
						}
					}
				}

				// Enforce MP4-only video uploads (shared rule: @/Utils/videoUploadFormats).
				if (vm.mp4Only && hasDisallowedVideoFile(el.files)) {
					vm.$notify({ group: 'error', text: MP4_ONLY_ERROR_MESSAGE });
					el.value = null;
					return;
				}
				this.$store.dispatch('Ui/addStreamToUpload', this.stream);
				Array.prototype.forEach.call(el.files, file => {
					// check for mime types
					const allowedExtensions = ["mp4"];
					const fileExtension = file.name.split(".").pop().toLowerCase();
					if (file.type.startsWith('video') && allowedExtensions.includes(fileExtension)) {
						vm.onMediaAdd(file,vm);
					} else {
						vm.$showModal("forbidden-file-format-modal-drop");
					}
				});

				el.value = null;
		},
		computeVideoPrecedence (video) {
			let precedence = 0;
			let siblingVids = this.videoFiles;
			if (video) {
				siblingVids = _.filter(this.videoFiles, v => v.id !== video.id);
			}
			precedence = _.size(siblingVids) + 1;

			return precedence;
		},
		onMediaAdd(file,vm) {
			// not allow multiple uploads if disabled
			
			this.showOptions = false;
			if (this.allowMultipleUploads === false && this.uploadList.length > 0) {
				return;
			}

			let trimmedName = file.name;
			const nameChunks = trimmedName.split('.');
			const extname = nameChunks.length > 1 ? nameChunks.pop() : '';
			let basename = nameChunks.join('.');
			if (basename.length > 20) {
				basename = `${basename.substr(0, 14)} ... ${basename.substr(basename.length - 6)}`;
			}
			trimmedName = basename + '.' + extname;

			const newVideo = {
				id: `unnamed_${Math.random().toString().slice(2)}`,
				fileName: trimmedName,
				fileNameOriginal: file.name,
				bytes: file.size,
				mediaInfo: null,
				precedence: this.computeVideoPrecedence(),
				enabled: true,
				removing: false,
				statusProcessing: false,

				file,
				uploadable: true,
				uploading: false,
				uploadProgress: 0,
				encodingPresets: [],
				encodingUnitsRequired: 0,
				presetListCollapse: true,
				durationExceeded: false
			};
			// this.uploadList = [newVideo, ...this.uploadList];
			this.$store.dispatch('Ui/addFileToUpload', newVideo);
			// const uploadItem = this.uploadList[0];
			const uploadItem = this.uploadFiles[0]
			utils.inspectMediaFile(this.mediaInfoLib, file, info => {
				const durationSec = info.duration;
				const durationMins = Math.ceil(
					(durationSec < 60 ? 60 : durationSec) / 60
				);

				const mappedInfo = { ...info, durationMins };
				// uploadItem.mediaInfo = mappedInfo;
				const file = newVideo
				this.$store.dispatch('Ui/addFileData', {uploadItem: file, mappedInfo});
				if (this.isTrialSub && info.duration > 10 * 60) {
					// uploadItem.durationExceeded = true;
					this.$store.dispatch('Ui/addFileData', {uploadItem: file, durationExceeded: true})
				}
				this.$emit('upload-inspected', { upload: uploadItem, handler: 'raw' });
				// console.log('media-info', info)
			});

			if (this.multipleUploads === false) {
				this.showUploadButton = false;
			}

			this.$emit('upload-enqueue', { upload: newVideo, handler: 'raw' });
		},
		async requestSignedUploadUrl(uploadItem) {
			const fileObj = uploadItem.file;
			const uploadPayload = {
				encodingPresets: uploadItem.encodingPresets,
				metadata: {
					size: fileObj.size,
					type: fileObj.type,
					originalFilename: fileObj.name,
					precedence: uploadItem.precedence
				},
				mediaInfo: uploadItem.mediaInfo,
				streamType: this.stream.type,
				multipartSupport: fileObj.size > 25 * 1024 * 1024
			};

			const uploadUrl = await StreamService.requestVodMediaUploadUrl(this.stream.type === 'scheduled' ? this.stream._id : this.stream.key, uploadPayload);
			return uploadUrl;
		},
		startMultipartBucketUpload (uploadId, uploadItem, uploadCredentials, onBytesUploaded) {
      return new Promise((resolve) => {
        uploadItem.uploading = true

        let AWS = window.AWS
        AWS.config.update({
          region: uploadCredentials.region,
          useAccelerateEndpoint: uploadCredentials.useAccelerateEndpoint
        })

        // Initialize the Amazon Cognito credentials provider
        let identityConf = {
          IdentityPoolId: uploadCredentials.poolId,
          LoginId: UserService.getUser(this.activeTeam).email
        }

        AWS.config.credentials = new AWS.CognitoIdentityCredentials(identityConf)

        // Upload the File
        const uploadBucket = new AWS.S3({ params: { Bucket: uploadCredentials.bucketName } })
        const uploadOpts = {
          Key: uploadCredentials.keyPrefix + uploadId,
          ContentType: uploadItem.file.type,
          Body: uploadItem.file,
          queueSize: uploadCredentials.concurrency || 2, // default 2 parts in parallel
          partSize: uploadCredentials.chunkSize || (2 * 1000 * 1000), // default 2MB
          UseAccelerateEndpoint: true
				}

        const onBytes = (ev) => {
					let percent = (ev.loaded * 100) / ev.total
					onBytesUploaded(percent)
        }

        let multipartUploadHandle = uploadBucket.upload(uploadOpts)
        multipartUploadHandle.on('httpUploadProgress', onBytes)

        uploadItem.cancelSource = {
          cancel: () => void multipartUploadHandle.abort()
        }

        multipartUploadHandle.send((err, data) => {
          if (err) {
            uploadItem.uploadProgress = 0
            uploadItem.uploadError = true
            uploadItem.cancelSource = null
            uploadItem.uploading = false
          }

          resolve(!err)
        })
      })
    },
		async onVideoUploaded(uploadItem, uploadResult) {
			if (!uploadResult || !uploadResult.fileId) return;

			const oldId = uploadItem.id;

			uploadItem.id = uploadResult.fileId;
			uploadItem.mediaInfo = uploadResult.mediaInfo;
			uploadItem.creationTime = new Date();

			if (uploadResult.encodingRequired) {
				uploadItem.encodingRequired = true;
				uploadItem.encodingStatus = 'processing';
			}

			uploadItem.uploadable = false;
			uploadItem.file = null;

			const uindex = this.uploadList.indexOf(uploadItem);
			const newVideoArray = utils.removeArrayItem(this.uploadList, uindex);
			this.uploadList = newVideoArray;

			this.$emit('new-video', uploadItem);
			this.$emit('upload-dequeue', {upload: oldId, handler: 'raw'});
			if (!this.uploadList.length) {
				this.$emit('video-queue-emptied');
			}
			await this.$store.dispatch('Streams/getStreams');
			await this.$store.dispatch('Streams/getFilesInVODFolder')
			this.$notify({
				group: 'success',
				text: 'Video uploaded successfully.'
			});
			this.$emit('video-added', uploadItem);
			setTimeout(() => {
				this.$notify({ group: 'info', text: 'Video added to media list' });
			}, 2000);
			this.showOptions = false;
		},
		cancelVideoUpload(media) {
			if (!media) return;

			if (media.cancelSource) {
				media.cancelSource.cancel();
			}

			media.uploading = false;
		},
		async removeVideoFile(media) {
			media.removing = true;

			this.$emit('upload-dequeue', {upload: media, handler: 'raw'});

			this.cancelVideoUpload(media);

			const index = this.uploadList.indexOf(media);
			this.uploadList.splice(index, 1);

			if (!this.uploadList.length) {
				this.$emit('video-queue-emptied');
				this.showUploadButton = true;
			}
		},
		async clearUploadList() {
			const uploadList = this.uploadList.slice();
			uploadList.forEach(vid => void this.removeVideoFile(vid));
		},
		async selectLiveToVod() {
			setTimeout(() => {
				showModal('modal-select-live-to-vod');
			}, 100);
		},
		onChange() {
			console.log('open drop');
      // this.uploadList = [...this.$refs.uploadInputDrop.files];
			this.initVideoUpload()
    },
    remove(i) {
      this.uploadList.splice(i, 1);
    },
    dragover(event) {
      event.preventDefault();
			// console.log(event.currentTarget);
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains('drop-zone-hidden_dragover')) {
        event.currentTarget.classList.remove('drop-zone-hidden_dragleave');
        event.currentTarget.classList.add('drop-zone-hidden_dragover');
      }
			if (event.currentTarget.classList.contains('w-full')) {
        event.currentTarget.classList.add('z-10');
      }
    },
    dragleave(event) {
			// Clean up
      event.currentTarget.classList.remove('drop-zone-hidden_dragover');
			if (event.currentTarget.classList.contains('w-full')) {
        event.currentTarget.classList.remove('z-10');
      }
    },
    drop(event) {
      event.preventDefault();
      this.$refs.uploadInputDrop.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add('drop-zone-hidden_dragleave');
      event.currentTarget.classList.remove('drop-zone-hidden_dragover');
    }
	}
};

function computeEncodingUnits(media) {
	if (!media.mediaInfo) return;
	const encUnits = media.mediaInfo.durationMins * media.encodingPresets.length;
	return encUnits > 0 ? Math.ceil(encUnits) : encUnits;
}
</script>

<style scoped>
.vod_uploadbox {
	width: 100%;
}
.vod_uploadbox_line-fix {
	margin-top: -4rem;
}
.vod_uploadbox .video-item {
		position: relative;
		z-index: 12;
		padding: .5rem 0;
}
.video-item + .video-item {
	border-top: 1px solid var(--c-dark-2);
}.uploader-body_line-fix {
	margin-top: -3.85rem;
}
.z-fix {
	position: relative;
	z-index: 1;
}
.progressbar-wrapper {
	height: 3px;
	border-radius: 3px;
	background-color: var(--c-dark-2);
}
.progress-label {
	position: absolute;
	top: 0;
	right: 1.75rem;
	color: var(--c-dark-6);
}
.drop-zone {
	padding: .25rem;
}
.drop-zone-tall {
	border: 1px dashed var(--c-dark-4);
	border-radius: 0.5rem;
	padding: .25rem;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	max-height: 100%;
	height: 80vh;
	max-width: 100%;
}
</style>

<style>
.vod_uploadbox + .video-list {
	opacity: 1;
	transition: .3s;
}
.vod_uploadbox:has(.drop-zone-hidden_dragover) + .video-list {
	opacity: 0;
	transition: .3s;
}
.z-10 {
	z-index: 10;
}
.drop-zone-circle {
	width: 220px;
	height: 220px;
}
</style>